/* import __COLOCATED_TEMPLATE__ from './app-package-owner-app.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();